<template>
<div id="app" class="flex column h100 justify-center">

	<div class="score flex" v-if="mode == 'TRAINING'">

		<div class="flex column" style="margin-right: 20px;">
			<div class="label">Racha</div>
			<div class="text">{{correctStreak}}</div>
		</div>
		<div class="flex column" style="margin-right: 20px;">
			<div class="label">Correctas</div>
			<div class="text">{{correct}}<span class="label">/{{correct+wrong}}</span></div>
		</div>
		<div class="flex column">
			<div class="label">Éxito</div>
			<div v-if="correct||wrong" class="text">{{parseInt(correct*100/(correct+wrong))}}<span class="label">%</span></div>
			<div v-else class="text">0<span class="label">%</span></div>
		</div>
	</div>

	<button class="score" v-if="mode != 'MENU'" @click="BackToMenu()">✖</button>

	<transition enter-active-class="slideIn" leave-active-class="slideOut">
	<div v-if="match" class="flex column align-center">
	
		<div class="flex justify-center align-center" style="margin: 40px 0px">
			<div class="flex column">
				<div class="type-label">Ataque ⚔</div>
				<img :class="`type ${match.attacker}`" :src="require(`./assets/${match.attacker}.png`)" width="128">
			</div>
			<div class="vs">VS</div>
			<div class="flex column">
				<div class="type-label">Defensa 🛡</div>
				<img :class="`type ${match.defender}`" :src="require(`./assets/${match.defender}.png`)" width="128">
			</div>
		</div>

		
		
	
		<div class="flex column w100" style="padding: 20px; width: 400px; max-width: 80%;">
			<button ref="NOT_VERY_EFFECTIVE" class="option bad" @click="SelectOption('NOT_VERY_EFFECTIVE')">No muy efectivo... 💩</button>
			<button ref="NEUTRAL" class="option neutral" style="margin: 10px 0px" @click="SelectOption('NEUTRAL')">Neutral 😐</button>
			<button ref="SUPER_EFFECTIVE" class="option good" @click="SelectOption('SUPER_EFFECTIVE')">¡Super efectivo! 💥</button>
		</div>

	</div>
	</transition>

	<div v-if="mode == 'MENU'" class="flex column align-center">

		<div class="flex column w100" style="padding: 20px; width: 400px; max-width: 80%;">

			<div class="flex column align-center" style="margin-bottom: 40px">
				<img src="./assets/logo.png" width="100">
			</div>

			<button class="option good" style="margin-bottom: 10px" @click="mode='EFFECTIVENESS'">Efectividad 🎯</button>
			<button class="option good" @click="mode='TRAINING'; NewMatch()">Entrenamiento 💪</button>
		</div>

	</div>

	<transition enter-active-class="slideIn" leave-active-class="slideOut">
	<div v-if="mode == 'EFFECTIVENESS'" class="flex column align-center h100">
	
		<div class="flex column align-center h100 justify-center">
			<div style="color: var(--green); margin-bottom: 10px">¡SUPER EFECTIVO!</div>
			<div class="flex justify-center" style="flex-wrap: wrap;">
				<div v-if="!typeMatchUp.superEffective.length" style="color: var(--secondary)">-</div>
				<img v-for="t in typeMatchUp.superEffective" :key="t" 
				:class="`type ${t}`" style="margin: 5px 2px"
				:src="require(`./assets/${t}.png`)" width="40">
			</div>

			<div style="color: var(--red); margin: 20px 0px 10px 0px">NO MUY EFECTIVO...</div>
			<div class="flex justify-center" style="flex-wrap: wrap;">
				<div v-if="!typeMatchUp.notVeryEffective.length" style="color: var(--secondary)">-</div>
				<img v-for="t in typeMatchUp.notVeryEffective" :key="t" 
				:class="`type ${t}`" style="margin: 5px 2px"
				:src="require(`./assets/${t}.png`)" width="40">
			</div>

		</div>

		<div class="flex justify-center align-center" style="flex-wrap: wrap; padding-bottom: 20px;">
			
			<img v-for="t in types" :key="t" 
			:class="`type ${t} selectable ${selectedTypes[t] ? 'selected' : ''}`" 
			@click="SelectType(t)"
			v-touch:touchhold="() => {SelectType(t, true)}"
			@contextmenu.prevent="() => {}"
			:src="require(`./assets/${t}.png`)" width="57">

		</div>

		

	</div>
	</transition>

</div>
</template>

<script>
const random = require('random').default;
const confetti = require('canvas-confetti').default;
export default {
	data() {
		return {
			mode: 'MENU',
			types: [
				'NORMAL',
				'FIRE',
				'WATER',
				'GRASS',
				'FLYING',
				'FIGHTING',
				'POISON',
				'ELECTRIC',
				'GROUND',
				'ROCK',
				'PSYCHIC',
				'ICE',
				'BUG',
				'GHOST',
				'STEEL',
				'DRAGON',
				'DARK',
				'FAIRY',
			],
			typesNames: {
				NORMAL: 'Normal',
				FIRE: 'Fuego',
				WATER: 'Agua',
				GRASS: 'Planta',
				FLYING: 'Volador',
				FIGHTING: 'Lucha',
				POISON: 'Veneno',
				ELECTRIC: 'Eléctrico',
				GROUND: 'Tierra',
				ROCK: 'Roca',
				PSYCHIC: 'Psíquico',
				ICE: 'Hielo',
				BUG: 'Bicho',
				GHOST: 'Fantasma',
				STEEL: 'Acero',
				DRAGON: 'Dragón',
				DARK: 'Siniestro',
				FAIRY: 'Hada',
			},
			effectiveness: {
				NORMAL: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: 0,
					POISON: 0,
					GROUND: 0,
					ROCK: -1,
					BUG: 0,
					GHOST: -2,
					STEEL: -1,
					FIRE: 0,
					WATER: 0,
					GRASS: 0,
					ELECTRIC: 0,
					PSYCHIC: 0,
					ICE: 0,
					DRAGON: 0,
					DARK: 0,
					FAIRY:0
				},
				FIGHTING: {
					NORMAL: +1,
					FIGHTING: 0,
					FLYING: -1,
					POISON: -1,
					GROUND: 0,
					ROCK: +1,
					BUG: -1,
					GHOST: -2,
					STEEL: +1,
					FIRE: 0,
					WATER: 0,
					GRASS: 0,
					ELECTRIC: 0,
					PSYCHIC: -1,
					ICE: +1,
					DRAGON: 0,
					DARK: +1,
					FAIRY: -1
				},
				FLYING: {
					NORMAL: 0,
					FIGHTING: +1,
					FLYING: 0,
					POISON: 0,
					GROUND: 0,
					ROCK: -1,
					BUG: +1,
					GHOST: 0,
					STEEL: -1,
					FIRE: 0,
					WATER: 0,
					GRASS: +1,
					ELECTRIC: -1,
					PSYCHIC: 0,
					ICE: 0,
					DRAGON: 0,
					DARK: 0,
					FAIRY:0
				},
				POISON: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: 0,
					POISON: -1,
					GROUND: -1,
					ROCK: -1,
					BUG: 0,
					GHOST: -1,
					STEEL: -2,
					FIRE: 0,
					WATER: 0,
					GRASS: +1,
					ELECTRIC: 0,
					PSYCHIC: 0,
					ICE: 0,
					DRAGON: 0,
					DARK: 0,
					FAIRY: +1
				},
				GROUND: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: -2,
					POISON: +1,
					GROUND: 0,
					ROCK: +1,
					BUG: -1,
					GHOST: 0,
					STEEL: +1,
					FIRE: +1,
					WATER: 0,
					GRASS: -1,
					ELECTRIC: +1,
					PSYCHIC: 0,
					ICE: 0,
					DRAGON: 0,
					DARK: 0,
					FAIRY:0
				},
				ROCK: {
					NORMAL: 0,
					FIGHTING: -1,
					FLYING: +1,
					POISON: 0,
					GROUND: -1,
					ROCK: 0,
					BUG: +1,
					GHOST: 0,
					STEEL: -1,
					FIRE: +1,
					WATER: 0,
					GRASS: 0,
					ELECTRIC: 0,
					PSYCHIC: 0,
					ICE: +1,
					DRAGON: 0,
					DARK: 0,
					FAIRY:0
				},
				BUG: {
					NORMAL: 0,
					FIGHTING: -1,
					FLYING: 0,
					POISON: -1,
					GROUND: 0,
					ROCK: 0,
					BUG: 0,
					GHOST: -1,
					STEEL: -1,
					FIRE: -1,
					WATER: 0,
					GRASS: +1,
					ELECTRIC: 0,
					PSYCHIC: +1,
					ICE: 0,
					DRAGON: 0,
					DARK: +1,
					FAIRY: -1
				},
				GHOST: {
					NORMAL: -2,
					FIGHTING: 0,
					FLYING: 0,
					POISON: 0,
					GROUND: 0,
					ROCK: 0,
					BUG: 0,
					GHOST: +1,
					STEEL: 0,
					FIRE: 0,
					WATER: 0,
					GRASS: 0,
					ELECTRIC: 0,
					PSYCHIC: +1,
					ICE: 0,
					DRAGON: 0,
					DARK: -1,
					FAIRY:0
				},
				STEEL: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: 0,
					POISON: 0,
					GROUND: 0,
					ROCK: +1,
					BUG: 0,
					GHOST: 0,
					STEEL: -1,
					FIRE: -1,
					WATER: -1,
					GRASS: 0,
					ELECTRIC: -1,
					PSYCHIC: 0,
					ICE: +1,
					DRAGON: 0,
					DARK: 0,
					FAIRY: +1
				},
				FIRE: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: 0,
					POISON: 0,
					GROUND: 0,
					ROCK: -1,
					BUG: +1,
					GHOST: 0,
					STEEL: +1,
					FIRE: -1,
					WATER: -1,
					GRASS: +1,
					ELECTRIC: 0,
					PSYCHIC: 0,
					ICE: +1,
					DRAGON: -1,
					DARK: 0,
					FAIRY:0
				},
				WATER: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: 0,
					POISON: 0,
					GROUND: +1,
					ROCK: +1,
					BUG: 0,
					GHOST: 0,
					STEEL: 0,
					FIRE: +1,
					WATER: -1,
					GRASS: -1,
					ELECTRIC: 0,
					PSYCHIC: 0,
					ICE: 0,
					DRAGON: -1,
					DARK: 0,
					FAIRY:0
				},
				GRASS: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: -1,
					POISON: -1,
					GROUND: +1,
					ROCK: +1,
					BUG: -1,
					GHOST: 0,
					STEEL: -1,
					FIRE: -1,
					WATER: +1,
					GRASS: -1,
					ELECTRIC: 0,
					PSYCHIC: 0,
					ICE: 0,
					DRAGON: -1,
					DARK: 0,
					FAIRY:0
				},
				ELECTRIC: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: +1,
					POISON: 0,
					GROUND: -2,
					ROCK: 0,
					BUG: 0,
					GHOST: 0,
					STEEL: 0,
					FIRE: 0,
					WATER: +1,
					GRASS: -1,
					ELECTRIC: -1,
					PSYCHIC: 0,
					ICE: 0,
					DRAGON: -1,
					DARK: 0,
					FAIRY:0
				},
				PSYCHIC: {
					NORMAL: 0,
					FIGHTING: +1,
					FLYING: 0,
					POISON: +1,
					GROUND: 0,
					ROCK: 0,
					BUG: 0,
					GHOST: 0,
					STEEL: -1,
					FIRE: 0,
					WATER: 0,
					GRASS: 0,
					ELECTRIC: 0,
					PSYCHIC: -1,
					ICE: 0,
					DRAGON: 0,
					DARK: -2,
					FAIRY:0
				},
				ICE: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: +1,
					POISON: 0,
					GROUND: +1,
					ROCK: 0,
					BUG: 0,
					GHOST: 0,
					STEEL: -1,
					FIRE: -1,
					WATER: -1,
					GRASS: +1,
					ELECTRIC: 0,
					PSYCHIC: 0,
					ICE: -1,
					DRAGON: +1,
					DARK: 0,
					FAIRY:0
				},
				DRAGON: {
					NORMAL: 0,
					FIGHTING: 0,
					FLYING: 0,
					POISON: 0,
					GROUND: 0,
					ROCK: 0,
					BUG: 0,
					GHOST: 0,
					STEEL: -1,
					FIRE: 0,
					WATER: 0,
					GRASS: 0,
					ELECTRIC: 0,
					PSYCHIC: 0,
					ICE: 0,
					DRAGON: +1,
					DARK: 0,
					FAIRY: -2
				},
				DARK: {
					NORMAL: 0,
					FIGHTING: -1,
					FLYING: 0,
					POISON: 0,
					GROUND: 0,
					ROCK: 0,
					BUG: 0,
					GHOST: +1,
					STEEL: 0,
					FIRE: 0,
					WATER: 0,
					GRASS: 0,
					ELECTRIC: 0,
					PSYCHIC: +1,
					ICE: 0,
					DRAGON: 0,
					DARK: -1,
					FAIRY: -1
				},
				FAIRY: {
					NORMAL: 0,
					FIGHTING: +1,
					FLYING: 0,
					POISON: -1,
					GROUND: 0,
					ROCK: 0,
					BUG: 0,
					GHOST: 0,
					STEEL: -1,
					FIRE: -1,
					WATER: 0,
					GRASS: 0,
					ELECTRIC: 0,
					PSYCHIC: 0,
					ICE: 0,
					DRAGON: +1,
					DARK: +1,
					FAIRY:0
				},
			},
			match: null,
			neutralStreak: 0,
			correct: 0,
			wrong: 0,
			correctStreak: 0,
			audioCorrect: null,
			audioWrong: null,
			selectedTypes: {}
		}
	},
	mounted() {
		this.audioCorrect = new Audio(require('./assets/ding.wav'));
		this.audioWrong = new Audio(require('./assets/quack.wav'));
		//this.NewMatch();
	},	
	methods: {
		GenerateMatch()
		{
			var typeAttacker = this.types[random.int(0, 17)];
			var typeDefender = this.types[random.int(0, 17)];
			var attack = this.effectiveness[typeAttacker];
			var damage = attack[typeDefender];
			
			var result = 'NEUTRAL';
			if(damage > 0) result = 'SUPER_EFFECTIVE';
			else if(damage < 0) result = 'NOT_VERY_EFFECTIVE';
			
			return {
				attacker: typeAttacker,
				defender: typeDefender,
				effectiveness1: attack,
				result: result,
				damage: damage
			};
		},
		NewMatch() {

			var match = null;
			var matchGenCount = -1;
			do {
				matchGenCount++;
				match = this.GenerateMatch();
				if(match.result == 'NEUTRAL') 
				{
					if(matchGenCount < this.neutralStreak)
					{
						match = null;
					}
				}
				else 
				{
					this.neutralStreak = 0;
				}
			} while(!match)

			if(match.result == 'NEUTRAL') this.neutralStreak++;

			this.match = match;
			
		},
		SelectOption(option)
		{
			if(option == this.match.result)
			{
				confetti({
					particleCount: 150,
					spread: 70,
					origin: { y: 1 }
				});
				this.audioCorrect.play();
				this.correct++;	
				this.correctStreak++;
			}
			else
			{
				this.audioWrong.play();
				this.wrong++;
				this.correctStreak = 0;
			}

			this.$refs.NOT_VERY_EFFECTIVE.classList.add(this.match.result == 'NOT_VERY_EFFECTIVE' ? 'correct' : 'wrong');
			this.$refs.NEUTRAL.classList.add(this.match.result == 'NEUTRAL' ? 'correct' : 'wrong');
			this.$refs.SUPER_EFFECTIVE.classList.add(this.match.result == 'SUPER_EFFECTIVE' ? 'correct' : 'wrong');

			setTimeout(() => {
				this.match = null;
				setTimeout(() => {
					this.match = null;
					this.NewMatch();		
				}, 300);	
			}, 1800);
			

		},
		BackToMenu() {
			if(this.mode == 'TRAINING')
			{
				this.match = null;
				setTimeout(() => {
					this.mode = 'MENU';
				}, 300);
			}
			else
			{
				this.mode = 'NONE';
				setTimeout(() => {
					this.mode = 'MENU';
				}, 300);
			}
			
			
		},
		SelectType(type, reset)
		{
			if(reset) this.selectedTypes = {};
			//var currentSelected = Object.keys(this.selectedTypes);
			//if(currentSelected.length >= 2) this.selectedTypes = {};
			if(this.selectedTypes[type]) this.$delete(this.selectedTypes, type);
			else this.$set(this.selectedTypes, type, true);

			var currentSelected = Object.keys(this.selectedTypes);
			if(currentSelected.length > 2) this.$delete(this.selectedTypes, type);
		}
	},
	computed: {
		typeMatchUp() {
			var ret = {
				superEffective: [],
				notVeryEffective: [],
			};
			var selectedTypes = Object.keys(this.selectedTypes);
			if(!selectedTypes.length) return ret;
			var typeVS = {
				NORMAL: 0,
				FIGHTING: 0,
				FLYING: 0,
				POISON: 0,
				GROUND: 0,
				ROCK: 0,
				BUG: 0,
				GHOST: 0,
				STEEL: 0,
				FIRE: 0,
				WATER: 0,
				GRASS: 0,
				ELECTRIC: 0,
				PSYCHIC: 0,
				ICE: 0,
				DRAGON: 0,
				DARK: 0,
				FAIRY:0
			};
			selectedTypes.forEach(selectedType => {
				this.types.forEach(type => {
					typeVS[type] += this.effectiveness[type][selectedType];
				});
			});
			
			this.types.forEach(type => {
				if(typeVS[type] > 0) ret.superEffective.push(type);
				else if(typeVS[type] < 0) ret.notVeryEffective.push(type);
			});

			return ret;
		},
	}
	
}
</script>

<style lang="scss">
:root {
	--green: #24aca0;
	--red: #da6780;
	--secondary: #869a9c;
}

* {
	box-sizing: border-box;
	-webkit-tap-highlight-color: transparent;
}
html, body {
	background-color: #e4f3f0;
	padding: 0;
	margin: 0;
	font-family: 'Lato', sans-serif;
	width: 100%;
	height: 100%;
}
#app {
	width: 100%;
	height: 100%;
	overflow: hidden;
}

.flex {
	display: flex;
	&.column {
		flex-direction: column;
	}
}

.h100 {height: 100%;}
.w100 {width: 100%;}
.justify-center {justify-content: center;}
.align-center {align-items: center;}

.option {
	cursor: pointer;
	border: none;
	border-radius: 50px;
	padding: 15px 20px;
	color: white;
	font-weight: 500;
	font-size: 16px;
	font-family: 'Lato', sans-serif;
	text-transform: uppercase;
	box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.1);
	transition: all 0.1s ease-out;

	&:hover	{
		transform: scale(1.08);
	}

	&.bad {
		background-color: var(--red);
	}
	&.good {
		background-color: var(--green);
	}
	&.neutral {
		background-color: var(--secondary);
	}

	&.correct {
		pointer-events: none;
		animation: anim-correct 2s ease-out forwards;
	}
	&.wrong {
		opacity: 0;
		pointer-events: none;
	}

}

.type-label {
	text-align: center;
	color: var(--secondary);
	font-size: 14px;
	margin-bottom: 10px;
}

.vs {
	background-color: var(--secondary);

	border-radius: 50%;
	color: white;
	margin: 20px 10px 0px 10px;
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 10px;
}

.score {
	border: none;
	position: absolute;
	left: 15px;
	top: 15px;
	background-color: white;
	border-radius: 10px;
	padding: 10px;
	box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);

	.text {
		font-size: 18px;
		color: var(--green);
		font-weight: 600;
		text-align: center;
	}
	.label {
		color:var(--secondary);
		font-size: 10px;
	}

}

button.score {
	height: 54px;
	width: 54px;
	right: 15px;
	left: auto;
	font-size: 20px;
	font-weight: 600;
	color: var(--secondary);
	cursor: pointer;
	transition: all 0.1s ease-out;
	&:hover {
		transform: scale(1.1);
	}
}

.type {
	border-radius: 50%;
	&.BUG {box-shadow: 0px 0px 40px 0px rgba(144,193,44,0.5);}
	&.DARK {box-shadow: 0px 0px 40px 0px rgba(90,83,102,0.5);}
	&.DRAGON {box-shadow: 0px 0px 40px 0px rgba(9,109,196,0.5);}
	&.ELECTRIC {box-shadow: 0px 0px 40px 0px rgba(243,210,59,0.5);}
	&.FAIRY {box-shadow: 0px 0px 40px 0px rgba(236,143,230,0.5);}
	&.FIGHTING {box-shadow: 0px 0px 40px 0px rgba(206,64,105,0.5);}
	&.FIRE {box-shadow: 0px 0px 40px 0px rgba(255,156,84,0.5);}
	&.FLYING {box-shadow: 0px 0px 40px 0px rgba(146,170,222,0.5);}
	&.GHOST {box-shadow: 0px 0px 40px 0px rgba(82,105,172,0.5);}
	&.GRASS {box-shadow: 0px 0px 40px 0px rgba(99,187,91,0.5);}
	&.GROUND {box-shadow: 0px 0px 40px 0px rgba(217,119,70,0.5);}
	&.ICE {box-shadow: 0px 0px 40px 0px rgba(116,206,192,0.5);}
	&.NORMAL {box-shadow: 0px 0px 40px 0px rgba(144,153,161,0.5);}
	&.POISON {box-shadow: 0px 0px 40px 0px rgba(171,106,200,0.5);}
	&.PSYCHIC {box-shadow: 0px 0px 40px 0px rgba(249,113,118,0.5);}
	&.ROCK {box-shadow: 0px 0px 40px 0px rgba(199,183,139,0.5);}
	&.STEEL {box-shadow: 0px 0px 40px 0px rgba(90,142,161,0.5);}
	&.WATER {box-shadow: 0px 0px 40px 0px rgba(77,144,213,0.5);}

	&.selectable {
		margin: 5px;
		transition: all 0.1s ease-out;
		cursor: pointer;
		opacity: 0.6;
		&:hover {
			transform: scale(1.1);
		}
	}
	&.selected {
		opacity: 1;
		transform: scale(1.1);
		outline: 3px solid #044742;
		box-shadow: 0px 0px 10px 5px var(--green);
	}

}

.slideIn {
	animation: anim-slide-in 0.2s ease-out forwards;
}
.slideOut {
	animation: anim-slide-out 0.2s ease-in forwards;
}

@keyframes anim-correct {
	50% {
		opacity: 1;
	}
	100% {
		opacity: 0;
		transform: scale(1.2);	
	}
}

@keyframes anim-slide-in {
	0% {
		opacity: 0;
		transform: translateX(100px);
	}
	100% {
		opacity: 1;
		transform: translateX(0px);
	}
}
@keyframes anim-slide-out {
	0% {
		opacity: 1;
		transform: translateX(0px);
	}
	100% {
		opacity: 0;
		transform: translateX(-100px);
	}
}

</style>
